import { render, staticRenderFns } from "./RollControls.vue?vue&type=template&id=6d4aa2c1&scoped=true"
import script from "./RollControls.vue?vue&type=script&lang=js"
export * from "./RollControls.vue?vue&type=script&lang=js"
import style0 from "./RollControls.vue?vue&type=style&index=0&id=6d4aa2c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4aa2c1",
  null
  
)

export default component.exports